<template>
  <div class="h-full flex flex-col">
    <iframe class="rounded h-full w-full h-dashboard-alerts" :src="dashboardUrl" frameborder="0">
    </iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { differenceInSeconds } from 'date-fns';
import { parseISO } from 'date-fns';

export default {
  name: 'AlertContent',
  data() {
    return {
      dashboardUrl: null,
    };
  },
  props: {
    loading: Boolean,
  },
  computed: {
    ...mapGetters('environment', [
      'getSelectedBatch',
      'getDashboardsSettings',
    ]),
    baseUrl: {
      get() {
        let baseUrl = process.env.VUE_APP_GRAFANA_URL;
        if (this.$route.name.includes('History')) {
          baseUrl += `d/${this.getDashboardsSettings?.alerts[this.$i18n.locale]}?orgId=1`;
        } else {
          baseUrl += `d/${this.getDashboardsSettings?.alerts_recent[this.$i18n.locale]}?orgId=1`;
        }
        return baseUrl;
      },
    },
  },
  methods: {
    getAgeRange(age) {
      if (age > 14) {
        return Array.from({ length: 15 }, (_, i) => (age - 14) + i).join(',')
      } else {
        return Array.from({ length: age }, (_, i) => i).join(',');
      }
    },
  },
  watch: {
    getSelectedBatch: {
      immediate: true,
      handler(batch) {
        if (!batch) {
          this.dashboardUrl = null;
          return;
        }
        this.$emit('set-loading', true);
        const url = new URL(this.baseUrl);

        let openingDate = differenceInSeconds(new Date(), parseISO(batch.openingDate)) + 60;

        url.searchParams.append('theme', 'light');
        url.searchParams.append('var-batch_id', batch.id);
        url.searchParams.append('to', 'now');

        if (this.$route.name == 'AlertHistoryDashboard' || this.$route.name == 'MatrixAlertHistoryDashboard') {
          url.searchParams.append('from', `now-${openingDate}s`);
          url.searchParams.append('var-ages', this.getAgeRange(batch.age));
        } else {
          url.searchParams.append('from', 'now-24h');
        }
        this.dashboardUrl = url.toString() + '&kiosk';
        this.$emit('set-loading', false);
      }
    }
  },
}
</script>

<style>
.h-dashboard-alerts {
  height: 1018px;
}

@media (max-width: 888px) {
  .h-dashboard-alerts {
    height: 1430px;
  }
}
</style>
